import { isEmpty } from "lodash";
import { segmentsApi } from "@/react/api/segmentsApi";
import type { CommunitySegmentRule } from "@/react/types/CommunitySegment";
import { removeEmptyValues } from "../components/AudienceMatchCounter/removeEmptyValues";
import type { TriggerWithRules } from "../types";
import { upsertSegment } from "./upsertSegment";

interface EntityWithRules {
  community_segment_id?: number | null;
  rules?: Omit<TriggerWithRules["rules"], "rule_type">;
}

export const saveEntityFilterRulesToSegment = async <T extends EntityWithRules>(
  entity: T,
): Promise<
  Omit<T, "rules" | "community_segment_id"> & {
    rules: CommunitySegmentRule;
    community_segment_id: number | null;
  }
> => {
  const { community_segment_id: communitySegmentId, rules, ...rest } = entity;
  const cleanedRules = removeEmptyValues(rules);

  if (cleanedRules && !isEmpty(cleanedRules)) {
    const segment = await upsertSegment({
      ...entity,
      rules: { rule_type: "custom_filters", rules: cleanedRules },
    });
    return {
      ...rest,
      rules: { rule_type: "custom_filters", rules: cleanedRules },
      community_segment_id: segment.id ?? null,
    };
  }

  if (communitySegmentId) {
    await segmentsApi.delete({ id: communitySegmentId });
    return {
      ...rest,
      rules: { rule_type: "custom_filters", rules: [] },
      community_segment_id: null,
    };
  }

  return {
    ...rest,
    rules: { rule_type: "custom_filters", rules: [] },
    community_segment_id: null,
  };
};
